// extracted by mini-css-extract-plugin
export var infoRow = "_tr-2";
export var labelContainer = "_tr-0";
export var rightInfo = "_tr-1";